<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base">
    <div class="container mt-40">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1 d-inline-block">
                {{ 'Marketing' }}
              </h4>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="w-100 client_dashboard">
          <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Campaigns" aria-label="campaigns">
              <div>
                <app-campaigns></app-campaigns>
              </div>
            </mat-tab>
            <mat-tab [label]="tabLabel" [aria-label]="tabLabel">
              <div>
                <div class="">
                  <div class="mt-3">
                    <div class="whiteWrap">
                      <div class="titleWrap">
                        <div class="row w-100">
                          <div class="col-sm-12">
                            <h4 class="mt-1 d-inline-block">
                              {{ tabLabel }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <app-upload-property-list></app-upload-property-list>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab
              label="Automated Recommendations"
              aria-label="Automated Recommendations"
              *ngIf="this.displayAutomatedRecommendations"
            >
              <div>
                <div class="">
                  <div class="mt-3">
                    <div class="whiteWrap">
                      <div class="titleWrap">
                        <div class="row w-100">
                          <div class="col-sm-12">
                            <h4 class="mt-1 d-inline-block">
                              {{ 'Automated Recommendations' }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <app-marketing-effectiveness></app-marketing-effectiveness>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
          <!-- Tabs end-->
        </div>
      </div>
    </div>
  </div>
</div>

<app-create-campaign-sheet
  (isCloseCampaignInfo)="onBack($event)"
  *ngIf="campaignState.openCreateCampaignSheet$ | async"
>
</app-create-campaign-sheet>
